import { Component, OnInit, Input } from '@angular/core';
import { MacroValues } from '../../../services/usda.service';

@Component({
  selector: 'macros',
  templateUrl: './macros.component.html',
  styleUrls: ['./macros.component.scss']
})
export class MacrosComponent implements OnInit {

  // chartType = "ColumnChart";
  chartType = "BarChart";
  // chartType = "Bubblechart";

  @Input() macroMap: Map<string, MacroValues>;

  // @Input() data: any;
  @Input() title: string;
  @Input() quantityLabel: string;
  // this.columnNames = ['Symbol', this.food.desc.name];
  @Input() columnNames: ['Blah', 'Stuff'];

  // @Input() options:any;
  // @Input() roles: any;
  // @Input() roles: any;
  // @Input() roles = { role: 'style' };
  roles = [
    // { role: 'style', type: 'string', index: 2 }
    { role: 'style' }
  ];

  data;

  // warnings:Array<string>;
  warnings: string;
  sugarWarningThresholdInGrams: number = 3;

  // clr: 'var(--ion-color-#{$color}-contrast-rgb';
  options = {
    // height: 600,
    // width: 1000,
    // colors: ['#e0440e'],
    colors: ['#24d6ea'],
    animation: {
      duration: 1000,
      easing: 'out',
    },
    hAxis: {
      title: 'Grams',
    },
    // bar: { groupWidth: '15%' },
    seriesType: 'bars',
    series: { 5: { type: 'line' } },
    dataOpacity: .6,
    legend: { position: 'top', maxLines: 2 },
  }

  constructor() { }

  onReady() {
    // console.log('chart is ready');
  }

  ngOnChanges() {
    this.initGraphData();
  }
  ngOnInit() {
    this.initGraphData();
  }

  initGraphData() {
    this.warnings = undefined;

    this.data = new Array();


    // this.data.push([this.macroMap.get('269').text, parseFloat(this.macroMap.get('269').value)]);
    if (this.macroMap.has('269')) {
      if (parseFloat(this.macroMap.get('269').value) >= this.sugarWarningThresholdInGrams) {
        this.warnings = 'Serving size contains excessive amounts of sugar (' + this.macroMap.get('269').value + '' + this.macroMap.get('269').unit + ')';
      }
  
      this.data.push(['Sugars', parseFloat(this.macroMap.get('269').value)]);
    }
    if (this.macroMap.has('203')) {
      this.data.push([this.macroMap.get('203').text, parseFloat(this.macroMap.get('203').value)]);
    }
    if (this.macroMap.has('291')) {
      this.data.push(['Fiber', parseFloat(this.macroMap.get('291').value)]);
    }
    if (this.macroMap.has('204')) {
      this.data.push(['Fat', parseFloat(this.macroMap.get('204').value)]);
    }

    /*this.data.push([this.macroMap.get('269').text, parseFloat(this.macroMap.get('269').value), 'color: gray']);
    this.data.push([this.macroMap.get('203').text, parseFloat(this.macroMap.get('203').value), 'color: #76A7FA']);
    this.data.push(['Fiber', parseFloat(this.macroMap.get('291').value), 'color: #76A7FA']);*/
  }
}
